import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const IntegrationsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Integrations",
    $_moduleTypesApiPath: "v1.0/Integrations/IntegrationTypes",
    $_integrations: [],
    $_currentIntegration: {},
    $_integrationTypes: [],
    $_integrationType: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allIntegrations: (state) => state.$_integrations,
    currentIntegration: (state) => state.$_currentIntegration,
    allIntegrationTypes: (state) => state.$_integrationTypes,
    currentIntegrationType: (state) => state.$_integrationType,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initIntegration({ commit }) {
      var integration = {
        id: 0,
        description: "",
        name: "",
        integrationTypeId: null,
        isActive: false,
        integrationTypeItems: []
      };
      commit("SET_INTEGRATION", integration);
    },
    clearIntegrations({ commit }) {
      commit("SET_INTEGRATIONS", []);
    },
    setIntegration({ commit }, integration) {
      commit("SET_INTEGRATION", integration);
    },

    async getIntegrationTypes(
      { commit, dispatch, state, rootGetters },
      returnData = false
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleTypesApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        if (returnData) {
          return response.data;
        } else {
          commit("SET_TYPES", response.data);
        }
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getIntegrationType(
      { commit, dispatch, state, rootGetters },
      { id, returnData = false }
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleTypesApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);

        if (returnData) {
          return response.data;
        } else {
          commit("SET_TYPE", response.data);
        }
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getIntegrations({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_INTEGRATIONS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async getIntegration({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_INTEGRATION", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async createIntegration(
      { commit, dispatch, state, rootGetters },
      integration
    ) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        integration.id = 0;
        const response = await axios.post(actionLink, integration, axiosConfig);
        integration.id = response.data.id;
        commit("SET_INTEGRATION", integration);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateIntegration({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(actionLink, data, axiosConfig);
        data.id = response.data.id;

        commit("SET_INTEGRATION", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deleteIntegration({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data;
      try {
        const response = await axios.delete(actionLink, $_axiosConfig);
        data.id = response.data.id;
        commit("SET_INTEGRATION", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_INTEGRATIONS(state, value) {
      state.$_integrations = value;
    },
    SET_INTEGRATION(state, value) {
      state.$_currentIntegration = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    },
    SET_TYPES(state, value) {
      state.$_integrationTypes = value;
    },
    SET_TYPE(state, value) {
      state.$_integrationType = value;
    }
  }
};

export default IntegrationsVuexModule;
